import React from 'react';

const AboutTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Zaineb Saidi',
      role: 'UX and graphic designer',
      image: '/team/zaineb.webp',
      description: 'Multidisciplinary Graphic & UX/UI Designer creating websites, mobile apps, branding, packaging, and social media visuals. Focused on building creative, user-centered designs that combine strong aesthetics with seamless functionality.',
      traits: ['Creative', 'Problem-solving', 'Reliable'],
      layout: 'right' // Image on right, content on left
    },
    {
      id: 2,
      name: 'Amine Hamdi',
      role: 'Developer',
      image: '/team/medamin.webp',
      description: 'A passionate Full Stack Engineer specializing in modern web technologies like Next.js, React, and Node.js. With a Computer Engineering background and experience across diverse projects, he brings technical expertise and a constant drive for innovation to every challenge.',
      traits: ['Ambitious', 'Visionary', 'Strategic'],
      layout: 'left' // Image on left, content on right
    },
    {
      id: 4,
      name: 'Anis Mhedhbi',
      role: 'Videographer',
      image: '/team/anis.webp',
      description: 'Shoots, and directs visual content, capturing real moments and shaping them into engaging, story-driven videos. Shoots, and directs visual content, capturing real moments and shaping them into engaging, story-driven videos. Shoots, and directs visual content.',
      traits: ['Ambitious', 'Visionary', 'Strategic'],
      layout: 'right'
    },
    {
      id: 5,
      name: 'Ayoub Ben Youssef',
      role: 'Video Editor',
      image: '/team/ayoub.webp',
      description: 'Ayoub Ben Youssef is a creative video editor specializing in crafting compelling visual stories that capture attention and drive engagement. With a strong sense of storytelling, rhythm, and aesthetics, he transforms raw footage into impactful content tailored for digital platforms. Combining creativity with strategic thinking, he delivers videos that not only look great but also serve clear branding and marketing goals.',
      traits: ['Creative', 'Strategic thinking', 'Dynamic'],
      layout: 'left'
    }
  ];

  return (
    <section className="py-12 md:py-20 px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-8 md:mb-16">
        <h2 className="text-2xl  md:text-4xl font-bold mb-3 md:mb-6">
          About the team
        </h2>
        <p className="text-sm md:text-lg text-gray-400 max-w-3xl">
          Young minds. High ambition. Zero limits. We think fast, create sharper, and execute with precision. 
          Here, leadership isn't a title. It's a standard we all carry.
        </p>
      </div>

      {/* Team Members */}
      <div className="space-y-12 md:space-y-20">
        {teamMembers.map((member, index) => (
          <div key={member.id} className={`flex flex-col lg:flex-row gap-4 md:gap-8 items-center ${
            member.layout === 'right' ? 'lg:flex-row-reverse' : ''
          }`}>
            
            {/* Image Card */}
            <div className="lg:w-1/2 flex justify-center">
              <div className="relative">
                {member.image ? (
                  <>
                    {/* Blue Background - positioned behind and below the image */}
                    <div 
                      className="w-64 h-64 md:w-[310px] md:h-[300px] rounded-3xl absolute bottom-0 right-0 z-0"
                      style={{ 
                        backgroundColor: 'var(--primary-blue)',
                        borderRadius: '28px'
                      }}
                    ></div>
                    
                    {/* Image - positioned in front and extends above the blue background */}
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-64 h-80 md:w-[310px] md:h-96 object-cover object-top relative z-10"
                      style={{ 
                        borderTopLeftRadius: '28px',
                        borderTopRightRadius: '28px',
                        borderBottomLeftRadius: '28px',
                        borderBottomRightRadius: '28px',
                        objectFit: 'cover',
                        objectPosition: 'top'
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/team/nour.webp';
                      }}
                    />
                  </>
                ) : (
                  <div 
                    className="w-64 h-64 md:w-80 md:h-80 rounded-3xl"
                    style={{ 
                      backgroundColor: 'var(--primary-blue)',
                      borderRadius: '28px'
                    }}
                  ></div>
                )}
              </div>
            </div>

            {/* Content */}
            <div className="lg:w-1/2 space-y-2 max-md:px-4 md:space-y-6">
              {/* Name and Role */}
              <div>
                <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <span className="text-gray-600 text-sm md:text-base flex items-center font-medium px-2 gap-2 rounded-full py-1 bg-gray-100">
                    <div className="w-2 h-2 bg-primary-blue rounded-full"></div>
                    {member.role}
                  </span>
                </div>
              </div>

              {/* Description */}
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                {member.description}
              </p>

              {/* Traits */}
              <div className="flex flex-wrap gap-2 md:gap-3">
                {member.traits.map((trait, traitIndex) => (
                  <div key={traitIndex} className="bg-gray-100 px-3 py-1 md:px-4 md:py-2 rounded-full">
                    <span className="text-gray-600 text-xs md:text-sm">{trait}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutTeam;